"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../../api/webAApi");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var moment = require("moment");
var AffilatesBrandsListCtl = /** @class */ (function (_super) {
    __extends(AffilatesBrandsListCtl, _super);
    function AffilatesBrandsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_affilate_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.affilate_id; });
        _this.dk_affilate_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.affilate_title; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_is_deprecated = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_deprecated; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this.dk_order_number = UIUtils_1.UIUtils.IProp2Str(function (o) { o.order_number; });
        _this._errDialog = errDialog;
        return _this;
    }
    AffilatesBrandsListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: []
        };
    };
    AffilatesBrandsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "affilate brand with id [" + id + "] not found !";
    };
    AffilatesBrandsListCtl.prototype.LoadData = function (brandId, onDone) {
        var _this = this;
        webAApi_1.ListPProgramBrandsByPProgramIdGet.exec({ pprogram_id: brandId }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    affilate_id: resp.list[i].pprogram_id,
                    affilate_title: resp.list[i].pprogram_title,
                    is_deprecated: resp.list[i].is_deprecated,
                    order_number: resp.list[i].order_number
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AffilatesBrandsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddPProgramBrand.exec({
            data: {
                brand_id: data.brand_id,
                pprogram_id: data.affilate_id,
                is_deprecated: data.is_deprecated,
                order_number: data.order_number
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                brand_id: data.brand_id,
                brand_title: resp.brand_title,
                date_changed2: moment(resp.date_added_uts_ms).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                affilate_id: data.affilate_id,
                affilate_title: resp.affilate_title,
                is_deprecated: data.is_deprecated,
                order_number: data.order_number
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AffilatesBrandsListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    AffilatesBrandsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeletePProgramBrand.exec({
                data: {
                    pprogram_brand_id: key,
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    AffilatesBrandsListCtl.prototype.DoSetIsDeprecated = function (key, isDeprecated, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetPProgramBrandIsDeprecated.exec({
                data: {
                    pprogram_brand_id: key,
                    is_deprecated: isDeprecated
                }
            }, function (resp) {
                _tmp.is_deprecated = isDeprecated;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    AffilatesBrandsListCtl.prototype.doSetOrderNumber = function (key, OrderNumber, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetPProgramBrandPriority.exec({
                data: {
                    pprogram_brand_id: key,
                    order_number: OrderNumber
                }
            }, function (resp) {
                _tmp.order_number = OrderNumber;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return AffilatesBrandsListCtl;
}(BaseController_1.BaseController));
exports.AffilatesBrandsListCtl = AffilatesBrandsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_pprograms_list/ctl/options/AffilatesBrandsListCtl.ts
// module id = 962
// module chunks = 0